<div>
  <pme-disconnected-sale-header></pme-disconnected-sale-header>
  <div class="window-padding">
    <router-outlet></router-outlet>
  </div>
  <!-- <pme-footer></pme-footer> -->
</div>
